import { Icon, Label } from 'semantic-ui-react';

type Role = { id: number; title?: string | null; type?: string | null };

/**
 * The volunteering opportunities a Volunteering Opportunity post carries, for the review, scheduled
 * and sent screens — the reviewer needs to see what the "I'll help" buttons will be for, not
 * just the text. Renders nothing for any other post.
 */
export function AdvertisedRoles({ roles }: { roles?: Role[] | null }) {
  if (!roles || roles.length === 0) return null;
  return (
    <div style={{ marginBottom: '1em' }}>
      <div style={{ fontSize: '0.85em', color: 'rgba(0,0,0,.6)', marginBottom: '0.3em' }}>
        <Icon name="hand paper outline" /> Advertising
      </div>
      {roles.map((role) => (
        <Label key={role.id} color="teal" basic size="small" style={{ marginBottom: '0.3em' }}>
          {role.title || 'Untitled opportunity'}
          {role.type && <Label.Detail>{role.type}</Label.Detail>}
        </Label>
      ))}
    </div>
  );
}
